import { render, staticRenderFns } from "./TextNotice.vue?vue&type=template&id=2329c3c6&scoped=true"
import script from "./TextNotice.vue?vue&type=script&lang=ts"
export * from "./TextNotice.vue?vue&type=script&lang=ts"
import style0 from "./TextNotice.vue?vue&type=style&index=0&id=2329c3c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2329c3c6",
  null
  
)

export default component.exports